export const countries = [
  { label: "Andorra", code: "AD" },
  { label: "United Arab Emirates", code: "AE" },
  { label: "Afghanistan", code: "AF" },
  { label: "Antigua and Barbuda", code: "AG" },
  { label: "Anguilla", code: "AI" },
  { label: "Albania", code: "AL" },
  { label: "Armenia", code: "AM" },
  { label: "Angola", code: "AO" },
  { label: "Antarctica", code: "AQ" },
  { label: "Argentina", code: "AR" },
  { label: "American Samoa", code: "AS" },
  { label: "Austria", code: "AT" },
  { label: "Australia", code: "AU" },
  { label: "Aruba", code: "AW" },
  { label: "Alland Islands", code: "AX" },
  { label: "Azerbaijan", code: "AZ" },
  { label: "Bosnia and Herzegovina", code: "BA" },
  { label: "Barbados", code: "BB" },
  { label: "Bangladesh", code: "BD" },
  { label: "Belgium", code: "BE" },
  { label: "Burkina Faso", code: "BF" },
  { label: "Bulgaria", code: "BG" },
  { label: "Bahrain", code: "BH" },
  { label: "Burundi", code: "BI" },
  { label: "Benin", code: "BJ" },
  { label: "Saint Barthelemy", code: "BL" },
  { label: "Bermuda", code: "BM" },
  { label: "Brunei Darussalam", code: "BN" },
  { label: "Bolivia", code: "BO" },
  { label: "Brazil", code: "BR" },
  { label: "Bahamas", code: "BS" },
  { label: "Bhutan", code: "BT" },
  { label: "Bouvet Island", code: "BV" },
  { label: "Botswana", code: "BW" },
  { label: "Belarus", code: "BY" },
  { label: "Belize", code: "BZ" },
  { label: "Canada", code: "CA" },
  { label: "Cocos (Keeling) Islands", code: "CC" },
  { label: "Congo, Democratic Republic of the", code: "CD" },
  { label: "Central African Republic", code: "CF" },
  { label: "Congo, Republic of the", code: "CG" },
  { label: "Switzerland", code: "CH" },
  { label: "Cote d'Ivoire", code: "CI" },
  { label: "Cook Islands", code: "CK" },
  { label: "Chile", code: "CL" },
  { label: "Cameroon", code: "CM" },
  { label: "China", code: "CN" },
  { label: "Colombia", code: "CO" },
  { label: "Costa Rica", code: "CR" },
  { label: "Cuba", code: "CU" },
  { label: "Cape Verde", code: "CV" },
  { label: "Curacao", code: "CW" },
  { label: "Christmas Island", code: "CX" },
  { label: "Cyprus", code: "CY" },
  { label: "Czech Republic", code: "CZ" },
  { label: "Germany", code: "DE" },
  { label: "Djibouti", code: "DJ" },
  { label: "Denmark", code: "DK" },
  { label: "Dominica", code: "DM" },
  { label: "Dominican Republic", code: "DO" },
  { label: "Algeria", code: "DZ" },
  { label: "Ecuador", code: "EC" },
  { label: "Estonia", code: "EE" },
  { label: "Egypt", code: "EG" },
  { label: "Western Sahara", code: "EH" },
  { label: "Eritrea", code: "ER" },
  { label: "Spain", code: "ES" },
  { label: "Ethiopia", code: "ET" },
  { label: "Finland", code: "FI" },
  { label: "Fiji", code: "FJ" },
  { label: "Falkland Islands (Malvinas)", code: "FK" },
  { label: "Micronesia, Federated States of", code: "FM" },
  { label: "Faroe Islands", code: "FO" },
  { label: "France", code: "FR" },
  { label: "Gabon", code: "GA" },
  { label: "United Kingdom", code: "GB" },
  { label: "Grenada", code: "GD" },
  { label: "Georgia", code: "GE" },
  { label: "French Guiana", code: "GF" },
  { label: "Guernsey", code: "GG" },
  { label: "Ghana", code: "GH" },
  { label: "Gibraltar", code: "GI" },
  { label: "Greenland", code: "GL" },
  { label: "Gambia", code: "GM" },
  { label: "Guinea", code: "GN" },
  { label: "Guadeloupe", code: "GP" },
  { label: "Equatorial Guinea", code: "GQ" },
  { label: "Greece", code: "GR" },
  { label: "South Georgia and the South Sandwich Islands", code: "GS" },
  { label: "Guatemala", code: "GT" },
  { label: "Guam", code: "GU" },
  { label: "Guinea-Bissau", code: "GW" },
  { label: "Guyana", code: "GY" },
  { label: "Hong Kong", code: "HK" },
  { label: "Heard Island and McDonald Islands", code: "HM" },
  { label: "Honduras", code: "HN" },
  { label: "Croatia", code: "HR" },
  { label: "Haiti", code: "HT" },
  { label: "Hungary", code: "HU" },
  { label: "Indonesia", code: "ID" },
  { label: "Ireland", code: "IE" },
  { label: "Israel", code: "IL" },
  { label: "Isle of Man", code: "IM" },
  { label: "India", code: "IN" },
  { label: "British Indian Ocean Territory", code: "IO" },
  { label: "Iraq", code: "IQ" },
  { label: "Iran, Islamic Republic of", code: "IR" },
  { label: "Iceland", code: "IS" },
  { label: "Italy", code: "IT" },
  { label: "Jersey", code: "JE" },
  { label: "Jamaica", code: "JM" },
  { label: "Jordan", code: "JO" },
  { label: "Japan", code: "JP" },
  { label: "Kenya", code: "KE" },
  { label: "Kyrgyzstan", code: "KG" },
  { label: "Cambodia", code: "KH" },
  { label: "Kiribati", code: "KI" },
  { label: "Comoros", code: "KM" },
  { label: "Saint Kitts and Nevis", code: "KN" },
  { label: "Korea, Democratic People's Republic of", code: "KP" },
  { label: "Korea, Republic of", code: "KR" },
  { label: "Kuwait", code: "KW" },
  { label: "Cayman Islands", code: "KY" },
  { label: "Kazakhstan", code: "KZ" },
  { label: "Lao People's Democratic Republic", code: "LA" },
  { label: "Lebanon", code: "LB" },
  { label: "Saint Lucia", code: "LC" },
  { label: "Liechtenstein", code: "LI" },
  { label: "Sri Lanka", code: "LK" },
  { label: "Liberia", code: "LR" },
  { label: "Lesotho", code: "LS" },
  { label: "Lithuania", code: "LT" },
  { label: "Luxembourg", code: "LU" },
  { label: "Latvia", code: "LV" },
  { label: "Libya", code: "LY" },
  { label: "Morocco", code: "MA" },
  { label: "Monaco", code: "MC" },
  { label: "Moldova, Republic of", code: "MD" },
  { label: "Montenegro", code: "ME" },
  { label: "Saint Martin (French part)", code: "MF" },
  { label: "Madagascar", code: "MG" },
  { label: "Marshall Islands", code: "MH" },
  { label: "Macedonia, the Former Yugoslav Republic of", code: "MK" },
  { label: "Mali", code: "ML" },
  { label: "Myanmar", code: "MM" },
  { label: "Mongolia", code: "MN" },
  { label: "Macao", code: "MO" },
  { label: "Northern Mariana Islands", code: "MP" },
  { label: "Martinique", code: "MQ" },
  { label: "Mauritania", code: "MR" },
  { label: "Montserrat", code: "MS" },
  { label: "Malta", code: "MT" },
  { label: "Mauritius", code: "MU" },
  { label: "Maldives", code: "MV" },
  { label: "Malawi", code: "MW" },
  { label: "Mexico", code: "MX" },
  { label: "Malaysia", code: "MY" },
  { label: "Mozambique", code: "MZ" },
  { label: "Namibia", code: "NA" },
  { label: "New Caledonia", code: "NC" },
  { label: "Niger", code: "NE" },
  { label: "Norfolk Island", code: "NF" },
  { label: "Nigeria", code: "NG" },
  { label: "Nicaragua", code: "NI" },
  { label: "Netherlands", code: "NL" },
  { label: "Norway", code: "NO" },
  { label: "Nepal", code: "NP" },
  { label: "Nauru", code: "NR" },
  { label: "Niue", code: "NU" },
  { label: "New Zealand", code: "NZ" },
  { label: "Oman", code: "OM" },
  { label: "Panama", code: "PA" },
  { label: "Peru", code: "PE" },
  { label: "French Polynesia", code: "PF" },
  { label: "Papua New Guinea", code: "PG" },
  { label: "Philippines", code: "PH" },
  { label: "Pakistan", code: "PK" },
  { label: "Poland", code: "PL" },
  { label: "Saint Pierre and Miquelon", code: "PM" },
  { label: "Pitcairn", code: "PN" },
  { label: "Puerto Rico", code: "PR" },
  { label: "Palestine, State of", code: "PS" },
  { label: "Portugal", code: "PT" },
  { label: "Palau", code: "PW" },
  { label: "Paraguay", code: "PY" },
  { label: "Qatar", code: "QA" },
  { label: "Reunion", code: "RE" },
  { label: "Romania", code: "RO" },
  { label: "Serbia", code: "RS" },
  { label: "Russian Federation", code: "RU" },
  { label: "Rwanda", code: "RW" },
  { label: "Saudi Arabia", code: "SA" },
  { label: "Solomon Islands", code: "SB" },
  { label: "Seychelles", code: "SC" },
  { label: "Sudan", code: "SD" },
  { label: "Sweden", code: "SE" },
  { label: "Singapore", code: "SG" },
  { label: "Saint Helena", code: "SH" },
  { label: "Slovenia", code: "SI" },
  { label: "Svalbard and Jan Mayen", code: "SJ" },
  { label: "Slovakia", code: "SK" },
  { label: "Sierra Leone", code: "SL" },
  { label: "San Marino", code: "SM" },
  { label: "Senegal", code: "SN" },
  { label: "Somalia", code: "SO" },
  { label: "Suriname", code: "SR" },
  { label: "South Sudan", code: "SS" },
  { label: "Sao Tome and Principe", code: "ST" },
  { label: "El Salvador", code: "SV" },
  { label: "Sint Maarten (Dutch part)", code: "SX" },
  { label: "Syrian Arab Republic", code: "SY" },
  { label: "Swaziland", code: "SZ" },
  { label: "Turks and Caicos Islands", code: "TC" },
  { label: "Chad", code: "TD" },
  { label: "French Southern Territories", code: "TF" },
  { label: "Togo", code: "TG" },
  { label: "Thailand", code: "TH" },
  { label: "Tajikistan", code: "TJ" },
  { label: "Tokelau", code: "TK" },
  { label: "Timor-Leste", code: "TL" },
  { label: "Turkmenistan", code: "TM" },
  { label: "Tunisia", code: "TN" },
  { label: "Tonga", code: "TO" },
  { label: "Turkey", code: "TR" },
  { label: "Trinidad and Tobago", code: "TT" },
  { label: "Tuvalu", code: "TV" },
  { label: "Taiwan", code: "TW" },
  { label: "United Republic of Tanzania", code: "TZ" },
  { label: "Ukraine", code: "UA" },
  { label: "Uganda", code: "UG" },
  { label: "United States", code: "US" },
  { label: "Uruguay", code: "UY" },
  { label: "Uzbekistan", code: "UZ" },
  { label: "Holy See (Vatican City State)", code: "VA" },
  { label: "Saint Vincent and the Grenadines", code: "VC" },
  { label: "Venezuela", code: "VE" },
  { label: "British Virgin Islands", code: "VG" },
  { label: "US Virgin Islands", code: "VI" },
  { label: "Vietnam", code: "VN" },
  { label: "Vanuatu", code: "VU" },
  { label: "Wallis and Futuna", code: "WF" },
  { label: "Samoa", code: "WS" },
  { label: "Kosovo", code: "XK" },
  { label: "Yemen", code: "YE" },
  { label: "Mayotte", code: "YT" },
  { label: "South Africa", code: "ZA" },
  { label: "Zambia", code: "ZM" },
  { label: "Zimbabwe", code: "ZW" },
];
